import { makeApiCall, makeFormApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/***************** GET PROMISE TO PAY REPORT START ************* */
export const promiseToPayReportListGet = (fetchData: any) => {
	const data = {
		GetPromiseToPayReportListToken: fetchData,
	};
	const url = `${API_URL}getPromiseToPayList`;
	return makeApiCall(url, data);
};
/***************** GET PROMISE TO PAY REPORT END ************* */

/******* START FETCH GROUP LOAN OFFICER LIST ***********/
export const fetchGroupLOanOfficerList = (fetchData: any) => {
	const data = {
		GroupLoanOfficerListToken: fetchData,
	};
	const url = `${API_URL}fetchGroupLoanOfficerList`;
	return makeApiCall(url, data);
};
/******* END FETCH GROUP LOAN OFFICER LIST ***********/

/** ***************** GET PROMISE TO PAY REPORT EXCEL START *********************** */
export const promiseToPayReportExcelget = (branchData: string) => {
	const params = new URLSearchParams();
	params.append('GetPromiseToPayReportExcelListToken', branchData);
	const url = `${API_URL}/Excel/PromiseToPayReports.php`;
	return makeFormApiCall(url, params);
};
/** ***************** GET PROMISE TO PAY REPORT EXCEL END *********************** */
